export enum PublicProductCompositePaymentPeriod {
  Once = 'ONCE',
  Monthly = 'MONTHLY',
  PerMonth = 'PER_MONTH',
}
